import { sumMonthlyPayments } from "web_myplann/Finances/Helpers/sumMonthlyPayments";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import { ClientFinancialPlanExpenseNameEnum } from "web_myplann/Infrastructure/Api/Api";
import type { OwnHomeInputs } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";

type Args = {
	expenseEntries: FinanceState["expenses"];
	totalIncome: number;
	totalExpenses: number;
};

export const mapBalanceToOwnHomeInputs = ({
	expenseEntries,
	totalIncome,
	totalExpenses,
}: Args): OwnHomeInputs => {
	const rent = sumMonthlyPayments(
		expenseEntries.filter(
			({ name }) => name === ClientFinancialPlanExpenseNameEnum.Rent,
		),
	);

	return {
		rent: rent > 0 ? rent : undefined,
		income: totalIncome > 0 ? totalIncome : undefined,
		expenses: totalExpenses > 0 ? totalExpenses : undefined,
	};
};
